<div mat-dialog-content style="margin: 0px; padding: 0px;">
    <app-clients-list [selectMode]="true" (clientSelected)="clientSelected($event)"></app-clients-list>
</div>